export const APPOINTMENT = 'Appointment';
export const BREAK = 'Break';
export const BLOCK = 'Block';
export const LEAVE = 'Leave';
